const canvasToBlobUrl = (canvas: HTMLCanvasElement): Promise<string> => new Promise(resolve => {
  canvas.toBlob(blob => blob && resolve(URL.createObjectURL(blob)));
});

export default canvasToBlobUrl;
